import Composables from '@/assets/images/sponsors/Composables.webp'
import JetBrains from '@/assets/images/sponsors/Jet_Brains.webp'
import LittleCaesars from '@/assets/images/sponsors/Little_Caesars.webp'
import MongoDB from '@/assets/images/sponsors/MongoDB.webp'
import GrandCircus from '@/assets/images/sponsors/Grand_Circus.webp'
import COMPES from '@/assets/images/sponsors/Compes.webp'

export const sponsorsData = [
  {
    id: 1,
    name: 'Little Caesars',
    logo: LittleCaesars,
    desc: `Headquartered in Detroit, Michigan, Little Caesars was founded by Mike and Marian Ilitch in 1959 as a single, family-owned restaurant. Today Little Caesars is the third largest pizza chain in the world with stores in each of the 50 U.S. states and 27 countries and territories.`,
    url: 'https://littlecaesars.com/en-us/',
  },
  {
    id: 2,
    name: 'MongoDB',
    logo: MongoDB,
    desc: `Build applications on the industry's first developer data platform. From AI-powered and event-driven apps to edge use cases and search, build fast and at the scale users demand.`,
    url: 'https://www.mongodb.com/',
  },
  {
    id: 3,
    name: 'Composables',
    logo: Composables,
    desc: `Professionally crafted Jetpack Compose UI components & resources.`,
    url: 'https://www.composables.com/',
  },
  {
    id: 4,
    name: 'JetBrains',
    logo: JetBrains,
    desc: `We help developers work faster by automating common, repetitive tasks to enable them to stay focused on code design and the big picture. We provide tools to explore and familiarize with code bases faster. Our products make it easy for you to take care of quality during all stages of development and spend less time on maintenance tasks.`,
    url: 'https://www.jetbrains.com/',
  },
  {
    id: 5,
    name: 'Grand Circus',
    logo: GrandCircus,
    desc: `Grand Circus is a virtual coding bootcamp that's been changing lives and careers since 2013. Our grads have landed roles with Amazon, Ford, Rocket Mortgage, and many more top employers. We've partnered with Apple, Google, and Meta to make tech careers more accessible to everyone.`,
    url: 'https://www.grandcircus.co/',
  },
  {
    id: 6,
    name: 'COMPES',
    logo: COMPES,
    desc: `The Coalition of Minority Professional Engineering Societies (COMPES) was formed in 2000 as an initiative between the NSBE, SHPE, and SWE Detroit professional chapters. The mission of this collaborative partnership is to support the local Detroit community in upskilling, career growth, networking, and provide access to new opportunities.`,
    url: 'http://compespdc.org/',
  },
]
